import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link as RouterLink } from 'react-router';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import CloseIcon from '@mui/icons-material/Close';
import { alertActions } from '@actions';
import Alert from './Alert';

const Toaster = () => {
    const [open, setOpen] = useState(false);
    const alerts = useSelector(state => state.alert.data);
    const dispatch = useDispatch();

    useEffect(() => {
        setOpen(!!alerts.length);
    }, [alerts]);

    useEffect(() => {
        const nonPersistent = alerts.filter(a => !a.persistent);
        if (nonPersistent.length) {
            const timeout = setTimeout(() => {
                dispatch(alertActions.clear(nonPersistent[0]?.id));
            }, 6000);

            return () => clearTimeout(timeout);
        }
    }, [alerts]);

    const handleClose = (reason, id) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        dispatch(alertActions.clear(id));
    };

    return (
        <Snackbar style={{ zIndex: 99999 }} open={open}>
            <div style={{ display: 'grid', gridGap: '8px' }}>
                {alerts.map(item =>
                    item.actionUrl || item.actionPath ? (
                        <Alert
                            key={item.id}
                            severity={item?.type || 'success'}
                            action={
                                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                    {item.actionUrl ? (
                                        <Link
                                            href={item.actionUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{ color: 'inherit', fontWeight: 600, cursor: 'pointer' }}
                                        >
                                            {item.actionLabel}
                                        </Link>
                                    ) : (
                                        <Link
                                            component={RouterLink}
                                            to={item.actionPath}
                                            onClick={() => handleClose(null, item.id)}
                                            sx={{ color: 'inherit', fontWeight: 600, cursor: 'pointer' }}
                                        >
                                            {item.actionLabel}
                                        </Link>
                                    )}
                                    <IconButton size="small" color="inherit" onClick={() => handleClose(null, item.id)}>
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </div>
                            }
                        >
                            {item?.message}
                        </Alert>
                    ) : (
                        <Alert
                            key={item.id}
                            severity={item?.type || 'success'}
                            onClose={(_, reason) => handleClose(reason, item.id)}
                        >
                            {item?.message}
                        </Alert>
                    ),
                )}
            </div>
        </Snackbar>
    );
};

export default Toaster;
